var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCubbyOrder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "car_1821562 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2969 3.0705H12.7054V5.88637H11.2969V3.0705Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.16016 3.0705H6.56866V5.88637H5.16016V3.0705Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.97266 3.0705H9.88816V5.88637H7.97266V3.0705Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.56641 7.2926H11.2967V11.2192H6.56641V7.2926Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24 13.6942L18.78 12.6254H0V14.0339H1.87594V15.4402H0V19.287H2.11162C2.11191 17.6065 3.4792 16.2394 5.15981 16.2394C6.84042 16.2394 8.20767 17.6065 8.208 19.287H15.792C15.7923 17.6065 17.1596 16.2394 18.8402 16.2394C20.5208 16.2394 21.888 17.6065 21.8884 19.287H24V13.6942Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.7031 7.2926V11.2192H18.071L16.1773 7.2926H12.7031Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.1623 11.2192V7.2926H1.73766L0.222656 11.2192H5.1623Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M5.79441 20.8055C6.6323 20.4582 7.03 19.4973 6.68269 18.6594C6.33538 17.8216 5.37458 17.4239 4.53668 17.7712C3.69878 18.1185 3.30108 19.0793 3.64839 19.9172C3.9957 20.7551 4.95651 21.1528 5.79441 20.8055Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M19.478 20.8011C20.3159 20.4538 20.7136 19.493 20.3663 18.6551C20.019 17.8172 19.0582 17.4195 18.2203 17.7668C17.3824 18.1141 16.9847 19.0749 17.332 19.9128C17.6793 20.7507 18.6401 21.1484 19.478 20.8011Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubbyOrder);
export default __webpack_public_path__ + "static/media/cubby_order.f141ac700961b63a923c8d449c27d39b.svg";
export { ForwardRef as ReactComponent };